import React, { useState } from 'react';
import { PageHeaderSection } from '../../../components/common/PageHeadSection';
import { useTranslation } from 'react-i18next';

const ContactUs = () => {
    const { t } = useTranslation();

    const [location] = useState({ lat: 36.9003634, lon: 30.6404928 });

    const [contactInfo] = useState({
        address: "Akdeniz Üni. Teknokent Arge-5 Binası 07058 Antalya /TÜRKİYE",
        phone: ["0850 777 0726", "0 530 857 29 70"],
        emails: {
            info: "info@hotel2sejour.com",
            support: "destek@hotel2sejour.com",
        },
    });

    const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${location.lon - 0.0025}%2C${location.lat - 0.0015}%2C${location.lon + 0.0025}%2C${location.lat + 0.0015}&layer=mapnik&marker=${location.lat}%2C${location.lon}`;
    const mapLink = `https://www.openstreetmap.org/?mlat=${location.lat}&mlon=${location.lon}#map=1/${location.lat}/${location.lon}`;

    return (
        <div className="nk-content">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <PageHeaderSection pageTitle={t("help.contactUs")} />
                        <div className="row">
                            <div className="col-md-6" style={{ height: '500px', marginBottom: '25px' }}>
                                {/* OpenStreetMap Embed Iframe with Zoom */}
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={mapUrl}
                                    style={{ border: '1px solid black', boxShadow: 'black 2px 5px 10px 2px' }}
                                    title="Harita"
                                ></iframe>
                                <br />
                                <small>
                                    <a href={mapLink} target="_blank" rel="noopener noreferrer">
                                        {t("help.contactInfo.viewLargerMap")}
                                    </a>
                                </small>
                            </div>

                            <div className="col-md-6">
                                <div className="col-md-12">
                                    <div className="form-body">
                                        <strong>{t("help.contactInfo.addressLabel")}</strong>
                                        <address>{contactInfo.address}</address>
                                        <address>
                                            <strong>{t("help.contactInfo.phoneLabel")}</strong>
                                            <br />
                                            {contactInfo.phone.map((num, index) => (
                                                <div key={index}>{num}</div>
                                            ))}
                                        </address>
                                        <address>
                                            <strong>{t("help.contactInfo.emailLabel")}</strong>
                                            <br />
                                            {t("help.contactInfo.forInfo")}: {contactInfo.emails.info}
                                            <br />
                                            {t("help.contactInfo.forSupport")}: {contactInfo.emails.support}
                                        </address>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
